import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import ConfigService from '../services/config.service';
const ConfigContext = createContext({
    config: null,
    isLoading: true,
    error: null,
    refreshConfig: async () => { },
});
export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const refreshConfig = async () => {
        try {
            setIsLoading(true);
            setError(null);
            const response = await ConfigService.getConfig();
            setConfig(response?.data?.data ?? null);
        }
        catch (err) {
            setError(err?.message ?? 'Failed to fetch config');
        }
        finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        refreshConfig();
    }, []);
    const value = useMemo(() => ({
        config,
        isLoading,
        error,
        refreshConfig,
    }), [config, isLoading, error]);
    return _jsx(ConfigContext.Provider, { value: value, children: children });
};
export const useConfig = () => useContext(ConfigContext);
